import { Dispatch } from 'redux';
import { api } from '../../service/api';
import { AUTH_ACTIONS } from './actions';

export const setAuth = (auth: any) => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.SET_AUTH,
    payload: auth,
  });
};
export const setIsAuthenticated = (auth: any) => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.SET_AUTHENTICATED,
    payload: auth,
  });
};
export const setGoogleProfile = (profile: any) => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.SET_PROFILE,
    payload: profile,
  });
};

export const login =
  (username: string, password: string) => (dispatch: Dispatch) => {
    return api
      .login({ username, password })
      .then((res) => {
        dispatch({
          type: AUTH_ACTIONS.LOGIN_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: AUTH_ACTIONS.LOGIN_FAILURE,
          payload: err.response.data.error,
        });
      });
  };

export const initialize = () => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.LOADING,
    payload: true,
  });
  api
    .validateAuthToken()
    .then((res) => {
      dispatch({
        type: AUTH_ACTIONS.LOGIN_SUCCESS,
        payload: res.data,
      });
    })
    .finally(() => {
      dispatch({
        type: AUTH_ACTIONS.LOADING,
        payload: false,
      });
    });
};

export const logout = () => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.LOGOUT,
  });
  api.logout().then((res) => {});
};

export const setTimeZone = (useLocal) => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_ACTIONS.UPDATE_TIMEZONE,
    payload: useLocal ? 'local' : 'UTC',
  });
};
